<template>
  <div>
    <el-footer class="hidden-sm-and-down" height="480px">
      <el-row class=" footer">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <div class=" footer_width">
            <div class="xdsk_top">
              <el-row :gutter="160" class="hidden-md-and-down">
                <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                  <div>
                    <img class="footer_img_xinshou" src="../../assets/home/xinshou.png"/>
                    <span class="footer_text3 footer_xinshou_left">新手指南</span>
                    <a href="/home.html#/college/category/7">
                    <div style="margin-top: 20px;" class="footer_text1 footer_kongjian_left">平台规则；服务条款；</div>
                    </a>
                  </div>
                </el-col>
                <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                  <div>
                    <img class="footer_img_duiwai" src="../../assets/home/duiwai.png"/>
                    <span class="footer_text3 footer_dsk_left">担保交易</span>
                    <a href="/user.html#/finan/account">
                    <div style="margin-top: 20px" class="footer_text1 footer_jiaoyi_left">交易方式；支付方式</div>
                    </a>
                  </div>
                </el-col>
                <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                  <img class="footer_img_shiming" src="../../assets/home/shiming.png"/>

                  <span class="footer_text3 footer_dsk_left">实名认证</span>
                  <a href="/user.html#/account/authentication">
                  <div style="margin-top: 20px" class="footer_text1 footer_jiaoyi_left">企业认证；个人认证</div>
                  </a>
                </el-col>
                <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                  <img class="footer_img_kefu" src="../../assets/home/kefu.png"/>
                  <span class="footer_text3 footer_dsk_left">客服中心</span>
                  <a href="">
                  <div style="margin-top: 20px" class="footer_text1 footer_tousu_left">投诉建议；交易维权；</div>
                  </a>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row class="footer footer_bottom">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <div class="footer_width">
            <div class="glzy_top">
              <a class="xuanzhong wenzi" href="/home.html#/college/category/3">
                <span class="footer_text2 footer_gyyyj_left">关于仪海仪家</span>
              </a>
              <a class="xuanzhong wenzi" href="">
                <el-tooltip placement="top" effect="light">
                  <div slot="content">
                    <span >电话：0532-80905521</span>
                    <br/>
                    <span >邮箱：yihaiyijia2019@163.com</span>
                  </div>
                  <span class="footer_text2 footer_gyyyj_left">联系我们</span>
                </el-tooltip>
              </a>

              <a class="xuanzhong wenzi" href="/home.html#/college/category/6">
                <span class="footer_text2 footer_lxwm_left">著作权与商标声明</span>
              </a>
              <a class="xuanzhong wenzi" href="/home.html#/college/category/5">
                <span class="footer_text2 footer_lxwm_left">隐私政策</span>
              </a>
              <a class="xuanzhong wenzi" href="/home.html#/college/category/7">
                <span class="footer_text2 footer_lxwm_left">平台规则</span>
              </a>
              <a class="xuanzhong wenzi" href="/home.html#/college/category/4">
                <span class="footer_text2 footer_lxwm_left">服务条款</span>
              </a>
            </div>
            <div class="glzy_bottom">
                <span class="footer_text2 ">
                  Copyright@2020 海粟智链（青岛）科技有限公司
                  版权所有鲁ICP备 19060515号-1
                </span>
                <span class="footer_text2 "  style="display: flex;justify-content: center; align-items: center;">
                    <img style="width:16px" alt="" src="../../assets/logo.gongan.png">
                        鲁公网安备37021402002353号
                </span>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-footer>
  </div>
</template>

<script>
    export default {
        // name: "footer"
        name: "footer0"
    }
</script>

<style scoped  lang="less">
  @import "../../../node_modules/element-ui/lib/theme-chalk/display.css";
  //@head_text : Source Han Sans CN;
  @font-face {
    font-family: 'Source-Han-Ligh27fa9ce3662351d';
  }
   a{
     text-decoration: none;
   }
  @import "../../assets/css/home";
  /*.footer {*/
  /*  width: 100%;*/
  /*  height: 255px;*/
  /*  background: #FFFFFF;*/
  /*  border-bottom: #E1E1E1 solid 1px;*/

  /*  .footer_width {*/
  /*    text-align: center;*/
  /*    width: 80%;*/
  /*    max-width: 1200px;*/
  /*    margin-right: auto;*/
  /*    margin-left: auto;*/

  /*    .xdsk_top {*/
  /*      position: relative;*/
  /*      margin-top: 70px;*/

  /*      .footer_img_xinshou {*/
  /*        //margin-left: 5px;*/
  /*        //margin-top: 13px;*/
  /*        position: absolute;*/
  /*        width: 50px;*/
  /*        height: 50px;*/
  /*      }*/

  /*      .footer_img_duiwai {*/
  /*        //margin-left: 155px;*/
  /*        //margin-top: 13px;*/
  /*        //margin-top: 13px;*/
  /*        position: absolute;*/
  /*        width: 50px;*/
  /*        height: 50px;*/
  /*      }*/

  /*      .footer_img_shiming {*/
  /*        //margin-left: 155px;*/
  /*        //margin-top: 13px;*/
  /*        position: absolute;*/
  /*        width: 50px;*/
  /*        height: 50px;*/
  /*      }*/

  /*      .footer_img_kefu {*/
  /*        //margin-left: 155px;*/
  /*        //margin-top: 13px;*/
  /*        position: absolute;*/
  /*        width: 50px;*/
  /*        height: 50px;*/
  /*      }*/

  /*      .footer_xinshou_left {*/
  /*        margin-left: 60px;*/
  /*      }*/

  /*      .footer_dsk_left {*/
  /*        margin-left: 60px;*/
  /*      }*/
  /*    }*/

  /*    .xdsk_bottom {*/
  /*      margin-top: 38px;*/

  /*      .footer_kongjian_left {*/
  /*        margin-left: 17px;*/
  /*      }*/

  /*      .footer_jiaoyi_left {*/
  /*        margin-left: 184px;*/
  /*      }*/

  /*      .footer_shiming_left {*/
  /*      }*/

  /*      .footer_tousu_left {*/
  /*        margin-left: 520px;*/
  /*      }*/

  /*      .footer_changjian_left {*/
  /*        margin-left: 945px;*/
  /*      }*/
  /*    }*/

  /*    .glzy_top {*/
  /*      margin-top: 51px;*/

  /*      .footer_gyyyj_left {*/
  /*        padding-right: 20px;*/
  /*        border-right: #E1E1E1 solid 1px;*/
  /*      }*/

  /*      .footer_lxwm_left {*/
  /*        margin-left: 29px;*/
  /*        padding-right: 21px;*/
  /*        border-right: #E1E1E1 solid 1px;*/
  /*      }*/
  /*    }*/

  /*    .glzy_bottom {*/
  /*      margin-top: 45px;*/
  /*    }*/
  /*  }*/
  /*}*/

  /*.footer_bottom {*/
  /*  border-bottom: none;*/
  /*  height: 223px;*/
  /*}*/

  /*.youfudong {*/
  /*  float: right;*/
  /*}*/

  /*.head_text {*/
  /*  font-size: 14px;*/
  /*  font-family: Source Han Sans CN;*/
  /*  font-weight: 150;*/
  /*  color: #333333;*/
  /*  line-height: 38px;*/
  /*}*/

  /*.footer_text1 {*/
  /*  font-size: 16px;*/
  /*  font-family: Source Han Sans CN;*/
  /*  font-weight: 150;*/
  /*  color: #666666;*/
  /*  //line-height: 30px;*/
  /*}*/

  /*.footer_text2 {*/
  /*  font-size: 16px;*/
  /*  font-family: Source Han Sans CN;*/
  /*  font-weight: 400;*/
  /*  color: #666666;*/
  /*  //line-height: 30px;*/
  /*}*/

  /*.footer_text3 {*/
  /*  font-size: 30px;*/
  /*  font-family: Source Han Sans CN;*/
  /*  font-weight: 550;*/
  /*  color: #333333;*/
  /*  //line-height: 30px;*/
  /*}*/
  .footer_width {
    text-align: center;
    width: 80%;
    max-width: 1200px;
    margin-right: auto;
    margin-left: auto;

    .xdsk_top {
      position: relative;
      margin-top: 70px;

      .footer_img_xinshou {
        //margin-left: 5px;
        //margin-top: 13px;
        position: absolute;
        width: 50px;
        height: 50px;
      }

      .footer_img_duiwai {
        //margin-left: 155px;
        //margin-top: 13px;
        //margin-top: 13px;
        position: absolute;
        width: 50px;
        height: 50px;
      }

      .footer_img_shiming {
        //margin-left: 155px;
        //margin-top: 13px;
        position: absolute;
        width: 50px;
        height: 50px;
      }

      .footer_img_kefu {
        //margin-left: 155px;
        //margin-top: 13px;
        position: absolute;
        width: 50px;
        height: 50px;
      }

      .footer_xinshou_left {
        margin-left: 60px;
      }

      .footer_dsk_left {
        margin-left: 60px;
      }
    }

    .xdsk_bottom {
      margin-top: 38px;

      .footer_kongjian_left {
        margin-left: 17px;
      }

      .footer_jiaoyi_left {
        margin-left: 184px;
      }

      .footer_shiming_left {
      }

      .footer_tousu_left {
        margin-left: 520px;
      }

      .footer_changjian_left {
        margin-left: 945px;
      }
    }

    .glzy_top {
      margin-top: 51px;

      .footer_gyyyj_left {
        padding-right: 20px;
        border-right: #E1E1E1 solid 1px;
      }

      .footer_lxwm_left {
        margin-left: 29px;
        padding-right: 21px;
        border-right: #E1E1E1 solid 1px;
      }
    }

    .glzy_bottom {
      margin-top: 45px;
    }
  }

  .footer_bottom {
    border-bottom: none;
    height: 223px;
  }

  .youfudong {
    float: right;
  }

  .head_text {
    font-size: 14px;
    font-family: Source Han Sans CN;
    color: #333333;
    line-height: 38px;
  }

  .footer_text1 {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 150px;
    color: #666666;
    //line-height: 30px;
  }

  .footer_text2 {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #666666;
    //line-height: 30px;
  }

  .footer_text3 {
    font-size: 30px;
    font-family: Source Han Sans CN;
    font-weight: 550px;
    color: #333333;
    //line-height: 30px;
  }
  .wenzi {
    text-decoration: none;
  }

  .xuanzhong:hover {
    text-decoration: none;
  }
</style>